import { Typography } from '@mui/material';

/**
 * Accessible inline validation message below fields.
 * @param {{ message?: string; id?: string }} props
 */
export function FormErrorText({ message, id }) {
  if (message == null || String(message).trim() === '') return null;
  return (
    <Typography
      id={id}
      component="p"
      role="alert"
      variant="caption"
      sx={(theme) => ({
        mt: { xs: 0.35, sm: 0.4, md: 0.5 },
        display: 'block',
        color: theme.palette.error.main,
        fontSize: { xs: '0.7rem', sm: '0.72rem', md: '0.75rem' },
        lineHeight: 1.35,
        fontWeight: 500,
      })}
    >
      {message}
    </Typography>
  );
}
